/**
 * Enum für Zugriff auf den Namen einer HTTP-Methode;
 * TBD: Prüfen, ob Veröffentlichung genutzt wird. Ziel ist es die Schnittstelle nur intern zu haben, um nur notwendige
 * Abhängigkeiten zu veröffentlichen bzw. funktionale und nicht-funktionale Anforderungen besser unterstützen zu können.
 */
export var HttpOperationType;
(function (HttpOperationType) {
  HttpOperationType["GET"] = "GET";
  HttpOperationType["POST"] = "POST";
  HttpOperationType["DELETE"] = "DELETE";
  HttpOperationType["HEAD"] = "HEAD";
  HttpOperationType["OPTIONS"] = "OPTIONS";
  HttpOperationType["PURGE"] = "PURGE";
  HttpOperationType["PUT"] = "PUT";
})(HttpOperationType || (HttpOperationType = {}));
/**
 * Aufbau des JWT-Payloads
 * @see  "Aufbau der JSON Web Tokens (JWT)" -> https://confluence.webapp.sdst.sbaintern.de/pages/viewpage.action?pageId=59646527
 */
export class JwtPayload {
}
//# sourceMappingURL=http.types.js.map
